import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import plTranslations from './locales/pl.json';
import arTranslations from './locales/ar.json';

// Map country codes to language codes
const countryToLanguage = {
  'FR': 'fr',
  'DE': 'de',
  'PL': 'pl',
  'SA': 'en', // Saudi Arabia
  'AE': 'en', // UAE
  'EG': 'en', // Egypt
  'IQ': 'en', // Iraq
  'JO': 'en', // Jordan
  'LB': 'en', // Lebanon
  'MA': 'en', // Morocco
  'DZ': 'en', // Algeria
  'TN': 'en', // Tunisia
  'LY': 'en', // Libya
  'SD': 'en', // Sudan
  'YE': 'en', // Yemen
  'OM': 'en', // Oman
  'KW': 'en', // Kuwait
  'QA': 'en', // Qatar
  'BH': 'en', // Bahrain
};

// Get language from country code
const getLanguageFromCountry = () => {
  const country = sessionStorage.getItem("gamesbox-country-code");
  if (country) {
    const countryUpper = country.toUpperCase();
    return countryToLanguage[countryUpper] || 'en';
  }
  return 'en';
};

// Get saved language preference or detect from country
const getInitialLanguage = () => {
  const savedLang = localStorage.getItem('gamesbox-language');
  if (savedLang) {
    return savedLang;
  }
  return getLanguageFromCountry();
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      pl: { translation: plTranslations },
      ar: { translation: arTranslations },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Handle RTL for Arabic
const updateDocumentDirection = (lang) => {
  if (typeof document !== 'undefined') {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }
};

// Set initial direction
updateDocumentDirection(i18n.language);

// Update direction when language changes
i18n.on('languageChanged', (lng) => {
  updateDocumentDirection(lng);
});

// Auto-detect language when country changes
const detectLanguageFromCountry = () => {
  const detectedLang = getLanguageFromCountry();
  const currentLang = i18n.language;
  if (detectedLang !== currentLang && !localStorage.getItem('gamesbox-language')) {
    i18n.changeLanguage(detectedLang);
  }
};

// Listen for country changes
if (typeof window !== 'undefined') {
  const checkCountry = () => {
    detectLanguageFromCountry();
  };
  
  // Check on load
  checkCountry();
  
  // Check periodically (in case country is updated)
  setInterval(checkCountry, 2000);
}

export default i18n;

